import { create } from 'zustand';
import type { IndicatorProps } from '@/interfaces/component/indicator.interface';

interface IndicatorState extends IndicatorProps {
  setShowIndicator: (showIndicator: boolean) => void;
}

export const useIndicatorStore = create<IndicatorState>((set) => ({
  showIndicator: false,
  setShowIndicator: (showIndicator) => set((state) => ({ ...state, showIndicator }))
}));
